import {LISTING_SECTION_IDS} from './listingSections.js'

export const PATHS = {
  ADS_LIST_SEARCH: '/search/',
  FAVORITES_LIST: '/user/favorites/',
  FAVORITES_LIST_DEALERS: '/user/favorites/dealers/',
  RENTING_STOCK: '/renting/concesionario/',
  STOCK: '/concesionario/',
  ALERT_MATCHES: '/user/alerts/:alertId/'
}

export const SECTION_PATHS = {
  INFORMATION: 'informacion',
  RATINGS: 'opiniones',
  RENTING_BUSINESS: 'empresas'
}

export const STOCK_PATHS_BY_LISTING_SECTION_ID = {
  [LISTING_SECTION_IDS.ALL_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.AUTOCARAVANS_AND_TRAILERS_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.BUGGIES_NEW_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.BUGGIES_SECOND_HAND_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.BUGGIES_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.CLASSIC_AND_COMPETITION_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.CLASSIC_MOTOS_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.KM0_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.MINIMOTOS_NEW_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.MINIMOTOS_SECOND_HAND_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.MINIMOTOS_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.NEW_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.NO_LICENSE_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_NEW_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_SECOND_HAND_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.RENTING_VEHICLES]: PATHS.RENTING_STOCK,
  [LISTING_SECTION_IDS.SECOND_HAND_VEHICLES]: PATHS.STOCK,
  [LISTING_SECTION_IDS.VANS_AND_COMMERCIAL_VEHICLES]: PATHS.STOCK
}

export const PATHS_BY_LISTING_SECTION_ID = {
  [LISTING_SECTION_IDS.ALL_VEHICLES]: PATHS.ADS_LIST_SEARCH,
  [LISTING_SECTION_IDS.FAVORITES_VEHICLES]: PATHS.FAVORITES_LIST,
  [LISTING_SECTION_IDS.ALERT_MATCHES_VEHICLES]: PATHS.ALERT_MATCHES
}
